import { useTheme } from '../context/ThemeContext';

function StatCard({ title, value, icon: Icon, color, trend }) {
  const { colors } = useTheme();

  return (
    <div 
      style={{
        background: colors.bgCard,
        backgroundImage: colors.gradientCard,
        borderRadius: '16px',
        padding: '1.25rem',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: colors.cardShadow,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'default',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = colors.cardHover;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = colors.cardShadow;
      }}
    >
      {/* Glow effect at top */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '80px',
        background: `radial-gradient(ellipse at center top, ${color}15 0%, transparent 70%)`,
        pointerEvents: 'none',
      }} />
      
      {/* Accent line */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: '1.25rem',
        right: '1.25rem',
        height: '2px',
        background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
        opacity: 0.6,
      }} />
      
      {/* Content */}
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            background: `${color}18`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 0 20px ${color}20`,
          }}>
            <Icon size={20} color={color} />
          </div>
          
          {trend && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem',
              padding: '0.25rem 0.6rem',
              borderRadius: '20px',
              fontSize: '0.7rem',
              fontWeight: 600,
              background: trend.isPositive ? colors.successMuted : colors.dangerMuted,
              color: trend.isPositive ? colors.success : colors.danger,
            }}>
              {trend.isPositive ? '↑' : '↓'} {trend.value}%
            </div>
          )}
        </div>
        
        <div style={{
          fontSize: '2rem',
          fontWeight: 700,
          color: colors.textPrimary,
          marginBottom: '0.25rem',
          fontFeatureSettings: '"tnum"',
          letterSpacing: '-0.02em',
        }}>
          {value}
        </div>
        
        <div style={{
          fontSize: '0.8rem',
          color: colors.textMuted,
          fontWeight: 500,
        }}>
          {title}
        </div>
      </div>
    </div>
  );
}

export default StatCard;